<table class="table table-eddy">
  <thead>
    <tr>
      <th style="width: 40%" scope="col">Setor</th>
      <th style="width: 15%" scope="col">Almoxarifado</th>
      <th style="width: 15%; text-align: right;" scope="col">Saldo Entrada</th>
      <th style="width: 15%; text-align: right;" scope="col">Saldo Saída</th>
      <th style="width: 15%; text-align: right;" scope="col">Saldo Atual</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of saldos">
      <td style="width: 40%">{{item.setor}}</td>
      <td style="width: 15%">{{item.almoxarifado}}</td>
      <td style="width: 15%; text-align: right;">{{item.sum_entrada | number:'1.2-2'}}</td>
      <td style="width: 15%; text-align: right;">{{item.sum_saida | number:'1.2-2'}}</td>
      <td style="width: 15%; text-align: right;">{{item.saldo_atual | number:'1.2-2'}}</td>
    </tr>
  </tbody>
</table>